import { default as domainCatalogGrid } from './grid/store'

export default {
    domainCatalogGrid
}
